import {StringLengthValidator} from "@/validators/StringLengthValidator";
import {NumberValidator} from "@/validators/NumberValidator";
import RequiredValidator from "@/validators/RequiredValidator";

export default class FrameAssemblyRules {

	public static readonly positionNrRules = [
		(new StringLengthValidator('frameAssembly.positionNr', true, null, 12)).validationRule(),
	];

	public static readonly cornerWidthRules = [
		(new NumberValidator('frameAssembly.width', true, 100, 100)).validationRule(),
		(new RequiredValidator('frameAssembly.width')).validationRule(),
	]

	public static readonly widthRules = [
		(new RequiredValidator('frameAssembly.width')).validationRule(),
	]

	public static readonly cornerHeightRules = [
		(new NumberValidator('frameAssembly.height', true, 100, 100)).validationRule(),
		(new RequiredValidator('frameAssembly.width')).validationRule(),
	]

	public static readonly heightRules = [
		(new RequiredValidator('frameAssembly.height')).validationRule(),
	]
}
